import update from 'immutability-helper';
const INIT_STATE = {
  data:null,
  active_applicant:null,
  provider:'illion',
  frollo_register_url:null,
}


export default (state = INIT_STATE,action) => {
    switch(action.type){
      case 'SET_BANKSTATEMENTS':
        return update(state,{
          data:{$set:action.payload}
        })
      case 'SET_BANKSTATEMENT_META':
        return update(state,{
          provider:{$set:action.payload.provider},
          frollo_register_url:{$set:action.payload.frollo_register_url}
        })
      default:
        return state
    }
  }
